// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KDxb","placeholdersHeader":"styles_placeholdersHeader__3GQwt","editorStyle":"styles_editorStyle__WtCIH","placeholdersBox":"styles_placeholdersBox__3Vm4X"};